import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TRequestType {
  code: string;
  name: string;
  valid: boolean;
}

export interface IRequestType extends TRequestType {}

const RequestType = Model(
  (model: TRequestType): IRequestType => {
    const _requestType: TRequestType = Object.assign({}, model);

    let create = (requestType: IRequestType): IRequestType => {
      let obj = ValidatableObject(requestType);
      return obj;
    };

    let requestType = {
      get code() {
        return _requestType.code;
      },
      set code(value) {
        _requestType.code = value;
      },
      get name() {
        return _requestType.name;
      },
      set name(value) {
        _requestType.name = value;
      },
      get valid() {
        return _requestType.valid;
      },
      set valid(value) {
        _requestType.valid = value;
      }
    };

    return create(requestType);
  }
);

export default RequestType;
